import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { isChild } from "Utils/ageUtils";
import { reverseAndPadDDMMYYYY } from "Utils/dateUtils";
import { firstNameSchema } from "Validation/index";
import { CHILD_MAX_AGE } from "../childConstants";
import { ChildProductDetailsFormValues } from "./childProductDetailsInterfaces";

export const validationSchema =
  () => (): Yup.ObjectSchema<ChildProductDetailsFormValues> => {
    const { getText } = TextManager;
    return Yup.object({
      childFirstName: firstNameSchema(),
      childBirthDate: Yup.string()
        .min(6, getText("childform.validation.childbirthdate-format"))
        .test(
          "childBirthDate",
          getText("childform.validation.childbirthdate-not_child_new", {
            variables: { maxAge: CHILD_MAX_AGE },
          }),
          (value) => {
            return value
              ? isChild(new Date(reverseAndPadDDMMYYYY(value)), CHILD_MAX_AGE)
              : true;
          },
        )
        .required(getText("childform.validation.childbirthdate-required")),
      parentGuardian: Yup.mixed<BooleanFormType>()
        .oneOf([BooleanFormType.TRUE], "")
        .required(getText("childform.validation.parentguardian")),
    }).defined();
  };
